import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import serviceClient from 'src/js/modules/service-client/service-client';
import getLocale from 'src/js/modules/i18n/selectors/locale';

const useCategoryLoadingBySlug = (categorySlug, onLoad) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const locale = useSelector(getLocale);

  useEffect(() => {
    const getCategoryBySlug = async (slug) => {
      try {
        const client = serviceClient.get();
        const { data } = await client.taxonomyGetPublicCategory({ slug, locale });

        onLoad(data);
      } catch (error) {
        console.error(error);
      }

      setIsLoaded(true);
    };

    if (categorySlug) {
      getCategoryBySlug(categorySlug);
    } else {
      setIsLoaded(true);
    }
  }, [categorySlug, locale, onLoad]);

  return isLoaded;
};

export default useCategoryLoadingBySlug;
